import * as turf from '@turf/turf';
export const VEGETATION_PRIORITY = ['other', 'crop', 'grass', 'scrub', 'wood'];

export const riskLevel = {
  0: 'very low',
  1: 'low',
  2: 'moderate',
  3: 'elevated',
  4: 'high',
  5: 'very high',
};

export function safeDeleteLot(draw, map, lotId) {
  if (!lotId) return;

  try {
    const mode = typeof draw.getMode === 'function' ? draw.getMode() : null;
    if (mode?.name === 'direct_select' || mode?.mode === 'direct_select') {
      draw.changeMode('simple_select');
    }
  } catch (e) { /* no-op */ }

  setTimeout(() => {
    if (draw.get(lotId)) {
      draw.delete(lotId);
    }
  }, 0);
}

export const setCurrentLotRing = (map, ring) => { map.__lotRing = Array.isArray(ring) ? ring.slice() : null; };
export const getCurrentLotRing = (map) => (Array.isArray(map.__lotRing) ? map.__lotRing.slice() : null);
export const clearCurrentLotRing = (map) => { map.__lotRing = null; };

export const extractBaseRing = (geom) => {
  if (!geom) return null;
  if (geom.type === 'Polygon') return (geom.coordinates?.[0] || []).slice();
  if (geom.type === 'MultiPolygon') return (geom.coordinates?.[0]?.[0] || []).slice();
  if (geom.type === 'LineString') return (geom.coordinates || []).slice();
  if (geom.type === 'MultiLineString') return (geom.coordinates?.[0] || []).slice();
  return null;
};

export function pickVegClassForPolygon(map, polyFeature) {
  if (!map || !polyFeature) return 'other';

  const landcoverLayer = map.getLayer('landcover-2');
  if (!landcoverLayer) return 'other';

  const features = map.querySourceFeatures(landcoverLayer.source, {
    sourceLayer: 'landcover'
  });
  if (!features.length) return 'other';

  const intersectClasses = new Set();
  features.forEach(f => {
    if (turf.booleanIntersects(polyFeature, f)) {
      intersectClasses.add(f.properties.class);
    }
  });

  let bestClass = 'other';
  intersectClasses.forEach(cls => {
    if (VEGETATION_PRIORITY.includes(cls)) {
      if (VEGETATION_PRIORITY.indexOf(cls) > VEGETATION_PRIORITY.indexOf(bestClass)) {
        bestClass = cls;
      }
    }
  });

  return bestClass;
}